import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { AuthService } from '../../_services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { clickGAEvent } from 'src/app/_helpers/ga-events';
import { addGAEventListener } from 'src/app/_helpers/ga-events';
import { removeGAEventListener } from 'src/app/_helpers/ga-events';
import { pageLoadEvent } from 'src/app/_helpers/ga-events';
import * as Sentry from '@sentry/angular-ivy';
const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';
declare var zcAction: any;

@Component({
  selector: 'tp-setpassword',
  templateUrl: './setpassword.component.html',
  styleUrls: ['./setpassword.component.css'],
})
export class SetpasswordComponent implements OnInit {
  validateForm!: UntypedFormGroup;
  submitted = false;
  tokenValue: string = '';
  errorMsg: string = '';
  errorValue = 'success';
  infobox = true;
  passwordVisible: boolean = false;
  passwordVisible2: boolean = false;
  tenant: boolean = false;
  logo: any;

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private notification: NzNotificationService
  ) {}

  ngOnInit() {
    this.checkIfTenant();
    pageLoadEvent('auth-set-password_page');
    addGAEventListener();
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.removeItem(USER_KEY);
    this.infobox = true;
    this.validateForm = this.fb.group({
      password: [null, [Validators.required, Validators.minLength(8)]],
      confirm: ['', [this.confirmValidator]],
    });
    this.route.queryParams.subscribe(
      (params) => {
        this.tokenValue = params['token'];
      },
      (error: any) => {
        Sentry.captureMessage('Error: ' + error);
      }
    );
  }

  ngAfterViewInit(): void {
    removeGAEventListener();
    addGAEventListener();
  }

  ngOnDestroy(): void {
    removeGAEventListener();
  }

  get f() {
    return this.validateForm.controls;
  }

  validateConfirmPassword(): void {
    setTimeout(() =>
      this.validateForm.controls.confirm.updateValueAndValidity()
    );
  }

  confirmValidator = (control: UntypedFormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { error: true, required: true };
    } else if (control.value !== this.validateForm.controls.password.value) {
      return { confirm: true, error: true };
    }
    return {};
  };

  submitForm() {
    this.submitted = true;
    for (const i in this.validateForm.controls) {
      if (this.validateForm.controls.hasOwnProperty(i)) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
      }
    }
    let body = {
      token: this.tokenValue,
      password: this.f.password.value,
    };
    this.authService.submitNewpassword(body).subscribe(
      (data) => {
        this.infobox = false;
        this.errorMsg = data.response;
        this.errorValue = data.error ? 'error' : 'success';
        if (data.error != true) {
          this.router.navigate(['/auth/login']);
          zcAction('set_password');
          this.createNotificationbox('success', data.response);
        } else {
          this.createNotificationbox('error', data.response);
        }
      },
      (err) => {
        Sentry.captureMessage('Error: ' + err);
        this.createNotificationbox('error', err.response);
      }
    );
  }
  checkIfTenant() {
    let getLink = window.location.href;
    const { hostname } = new URL(getLink);

    const isTenant = localStorage.getItem('tenant');
    if (isTenant === 'true') {
      this.tenant = true;
      this.logo =
        hostname === 'fidelity-cpaas.terragonltd.com'
          ? '../assets/icons/fidelity.svg'
          : hostname === 'oxygen-cpaas.terragonltd.com'
          ? '../assets/icons/oxygen.svg'
          : hostname === 'abstaging-cpaasdev.terragoncpaas.com'
          ? '../assets/icons/access.svg'
          : hostname === 'ocpaasstaging.terragonbase.com' ||
            hostname === 'acc-cpaas.terragonltd.com'
          ? '../assets/icons/terragonLogo.svg'
          : hostname === 'aramex.terragoncpaas.com'
          ? '../assets/icons/aramex.svg'
          : hostname === 'hydrogencpaas.terragoncpaas.com'
          ? '../assets/icons/hydrogen.svg'
          : '../assets/icons/user-dummy.png';
    } else {
      this.tenant = false;
      this.logo = '../../../assets/icons/terragonLogo.svg';
    }
  }

  createNotificationbox(type: string, data: string): void {
    this.notification.create(type, type, data);
  }

  togglePasswordVisibility() {
    clickGAEvent(
      'show_password',
      'setpassword-password-visibility_click',
      'auth-setpassword_page'
    );
    this.passwordVisible = !this.passwordVisible;
  }

  togglePasswordVisibility2() {
    clickGAEvent(
      'show_password',
      'setpassword-password-visibility_click',
      'auth-setpassword_page'
    );
    this.passwordVisible2 = !this.passwordVisible2;
  }

  triggerGAInput(inputName: string): void {
    clickGAEvent(
      'input_text',
      'setpassword' + inputName,
      'auth-setpassword_page'
    );
  }

  triggerGAButton(): void {
    clickGAEvent('button_click', 'set-password_click', 'auth-setpassword_page');
  }
}
